import PasswordVerifyModal from './PasswordVerifyModal'

export default PasswordVerifyModal
